// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React, { ReactElement } from 'react'
import classnames from 'classnames'
import './index.less'

export interface ICollapseProps {
  collapsed?: boolean
  onChange?: (collapse: boolean) => void
  children: any
  header: string | React.ReactNode
  className?: string
  defaultCollapsed?: boolean
}

export interface ICollapseState {
  collapsed: boolean
  contentHeight: number
}

export class Collapse extends React.Component<ICollapseProps, ICollapseState> {
  private content = React.createRef<HTMLDivElement>()

  static defaultProps = {
    onChange: (collapsed: boolean) => {}
  }

  constructor (props: ICollapseProps) {
    super(props)
    let collapsed
    if ('defaultCollapsed' in props) {
      collapsed = props.defaultCollapsed
    } else if ('collapsed' in props) {
      collapsed = props.collapsed
    } else {
      collapsed = true
    }
    this.state = {
      collapsed,
      contentHeight: 0
    }
  }

  componentDidMount () {
    if (!this.state.collapsed) {
      this.setState({
        contentHeight: this.calulateContentHeight(this.state.collapsed)
      })
    }
  }

  private handleClick = () => {
    const { onChange } = this.props
    if ('defaultCollapsed' in this.props) {
      this.setState({
        collapsed: !this.state.collapsed,
        contentHeight: this.calulateContentHeight(!this.state.collapsed)
      })
    }
    onChange(!this.state.collapsed)
  }

  private calulateContentHeight = collapsed => {
    let height = 0
    if (!collapsed) {
      let element = this.content.current.firstElementChild
      height += (element as HTMLElement).offsetHeight
      while (element.nextElementSibling) {
        height += (element.nextElementSibling as HTMLElement).offsetHeight
        element = element.nextElementSibling
      }
      height += 2
    }

    return height
  }

  UNSAFE_componentWillReceiveProps (nextProps: ICollapseProps) {
    if (this.isDefaultCollapsedPropertyChanged(this.props, nextProps)) {
      throw new Error('Only allowed use either "defaultCollapsed" and "collapsed"')
    }
    if (nextProps.collapsed !== this.props.collapsed) {
      this.setState({
        contentHeight: this.calulateContentHeight(nextProps.collapsed)
      })
    }
  }

  private isDefaultCollapsedPropertyChanged (props, nextProps): boolean {
    return (
      (!('defaultCollapsed' in nextProps) && 'defaultCollapsed' in props) ||
      ('defaultCollapsed' in nextProps && !('defaultCollapsed' in props))
    )
  }

  render () {
    const { header, children, className } = this.props
    const { collapsed } = this.state
    const wrapperClassnamne = classnames('collapse', className)
    const contentClassname = classnames('collapse-content', {
      inactive: collapsed
    })
    const Header = typeof header === 'string' ? <div>{header}</div> : header
    return (
      <div className={wrapperClassnamne}>
        {React.cloneElement(Header as ReactElement, { onClick: this.handleClick })}
        <div className={contentClassname} ref={this.content}>
          {children}
        </div>
      </div>
    )
  }
}
